import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useClient } from './useClient';

export function useToggleByHash(hash, onOpenHook, onCloseHook) {
  const router = useRouter();
  const isClient = useClient();

  const url = useMemo(() => {
    if (!isClient) return null;
    return new URL(router.asPath, window.location.origin);
  }, [isClient, router.asPath]);

  const isOpen = useMemo(() => {
    if (!isClient) return false;
    return window.location.hash === hash;
  }, [isClient, hash, router.asPath]);

  function open() {
    onOpenHook?.();
    url.hash = hash;
    router.push(url);
  }

  function close() {
    onCloseHook?.();
    url.hash = '';
    router.push(url);
  }

  return { open, close, isOpen };
}
